import React, { useState, useEffect } from "react";
import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import InputMask from "react-input-mask";
import { Link, useHistory } from "react-router-dom";
import styles from "../../../styles/global-styles";
import CategorySelect from "../../shared/selects/CategorySelect";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import ProductResume from "../inventory/product/ProductResume";
import { ProductService } from "../../../services/product.service";
import { GuaranteeService } from "../../../services/guarantee.service";
import { AuthService } from "../../../services/auth.service";
import { Role } from "../../../_utils/roleEnum";
import ClientInfo from "../shopping-cart/ClientInfo";
import { SellService } from "../../../services/sell.service";
import { customDate } from "../../../_utils/utils";

const usetSyles = makeStyles((theme) => ({
  numberCircle: styles.numberCircle,
  backgroundIcon: styles.backgroundIcon,
  rightButton: styles.buttonRightHeader,
  link: styles.link,
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "auto",
    },
  },
  detailTitle: {
    fontWeight: "800",
    color: "#1C2668",
    marginTop: theme.spacing(4),
    marginBottom: -15,
  },
}));

const NewGuarantee = ({ addAlert, detailAlert, guaranteeInfo }) => {
  const classes = usetSyles();
  const history = useHistory();

  const [guaranteeObject, setGuaranteeObject] = useState({});
  const [optionSelected, setOptionSelected] = useState({});
  const { siteId, id } = AuthService.currentUserValue;

  const [productDetail, setProductDetail] = useState(null);
  const [productId, setProductId] = useState(undefined);
  const [barCode, setBarCode] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [sellInfo, setSellInfo] = useState({});

  useEffect(() => {
    console.log("guaranteeInfo DATA ===== ", guaranteeInfo);
    if (guaranteeInfo && guaranteeInfo.product?.movile) {
      const {
        product: {
          movile: { imeiCode },
        },
      } = guaranteeInfo;
      setGuaranteeObject(guaranteeInfo);
      findMovileInfo(imeiCode);
    }
  }, []);

  useEffect(() => {
    (async function fetchData() {
      if (
        !guaranteeInfo &&
        guaranteeObject.productId &&
        guaranteeObject.serviceTicket &&
        guaranteeObject.siteId &&
        clientId
      ) {
        try {
          const { data } = await GuaranteeService.createGuarantee(
            guaranteeObject
          );
          console.log("guarantee created", data);
          if (data)
            history.push({
              pathname: `/dashboard/inventario/nueva-garantia/service-ticket/${data.serviceTicket}`,
              state: data.serviceTicket,
            });
        } catch (error) {
          addAlert({ showAlert: true });
          detailAlert({ severity: "error", message: error.msgs });
        }
      }
    })();
  }, [guaranteeObject]);

  const handleSubmitForm = (event) => {
    console.log("siteId from const", siteId);
    event.preventDefault();
    const serviceTicket = generateTicket();
    setGuaranteeObject({
      ...guaranteeObject,
      productId,
      serviceTicket,
      siteId,
      clientId,
      statusGuaranteeId: 1,
    });
  };

  const generateTicket = () => Math.floor(Math.random() * 1000000);

  const handleInputText = ({ target: { name, value } }) =>
    setGuaranteeObject({ ...guaranteeObject, [name]: value });

  const handleBarCode = ({ target: { value } }) => setBarCode(value);

  const handleCategorySelected = (key, value) => setOptionSelected(value);

  const findMovileInfo = async (imeiCode) => {
    try {
      const { data } = await ProductService.getMovileProductByImei(
        guaranteeObject.imeiCode || imeiCode
      );
      if (data) {
        setProductId(data.id);
        setProductDetail(data.movile);
        const sellData = await SellService.getAllSellsWithParams({
          siteId,
          userId: id,
          clientId,
        });
        if (sellData.data.length) {
          const productSold = sellData.data.filter(
            (item) => item.productId === data.id
          );
          if (productSold.length) {
            // console.log("productSold", productSold[0]);
            setSellInfo(productSold[0]);
          } else {
            addAlert({ showAlert: true });
            detailAlert({
              severity: "info",
              message:
                "El IMEI correspondiente a ese equipo móvil no se encuentra vendido",
              time: 3000,
            });
          }
        }
      } else {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "warning",
          message:
            "No encontró equipo movil con ese IMEI, realizar nueva busqueda",
          time: 3000,
        });
      }
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: "Error al hacer la búsqueda del equipo móvil",
      });
    }
  };

  const findAccesoryInfo = async () => {
    try {
      const queryParams = { barCode, productSold: 1 };
      const { data } = await ProductService.getAccesoryProductByParams(
        queryParams
      );
      console.log("data", data);
      const productsWithClientId = [];
      data.forEach((item, i) => {
        productsWithClientId.push({
          productId: item.id,
          siteId,
          userId: id,
          clientId,
        });
      });
      const sellData = await SellService.getAllSellsWithParams({
        siteId,
        userId: id,
        clientId,
      });
      // console.log("productsWithClientId", productsWithClientId);
      // console.log("sellData", sellData.data);
      if (sellData.data.length) {
        sellData.data.forEach((item) => {
          productsWithClientId.forEach((product) => {
            if (product.productId === item.productId) {
              console.log("product ========", item);
              setProductId(item.productId);
              setProductDetail(item.product.accesory);
              setSellInfo(item);
            }
          });
        });
      } else {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "warning",
          message:
            "No  se encontró un accesorio con ese código de barras, realizar nueva búsqueda",
          time: 3000,
        });
      }
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: "Error al hacer la búsqueda del accesorio",
      });
    }
  };

  const recoverMovileDetail = (e) => {
    e.preventDefault();
    findMovileInfo();
  };

  const recoverAccesoryInfo = (e) => {
    e.preventDefault();
    findAccesoryInfo();
  };

  const validateCancelLink = () => {
    let link = "";
    if (
      AuthService.currentUserValue.roleId === Role.Admin ||
      AuthService.currentUserValue.roleId === Role.GuaranteeHelper
    ) {
      link = "/dashboard/garantias";
    } else link = `/dashboard/inventario/garantias`;
    return link;
  };

  const handleClientFound = async (addclient, clientObject) => {
    console.log("clientObject", clientObject);
    setClientId(clientObject.id);
  };

  return (
    <>
      <div style={{ display: "inline-flex" }}>
        <ArrowBackIosIcon color="primary" />
        <Typography variant="body1" component={"div"}>
          <Box>
            {" "}
            <Link to={validateCancelLink} className={classes.link}>
              Cancelar
            </Link>
          </Box>
        </Typography>
      </div>

      <Box mt={3} style={{ fontWeight: "bold", color: "#1C2668" }}>
        <Typography variant="h4">
          Service ticket {guaranteeInfo?.serviceTicket}
        </Typography>
        {!guaranteeInfo ? (
          <Typography variant="body1" component={"div"}>
            Completa los pasos para crear una garantía
          </Typography>
        ) : (
          <Box mb={-3}>
            <Typography variant="h6" style={{ fontWeight: 300 }}>
              Fecha de alta: {customDate(guaranteeInfo?.createdAt)}
            </Typography>
            <Typography variant="h5" className={classes.detailTitle}>
              Detalles del cliente
            </Typography>
          </Box>
        )}
      </Box>

      <ValidatorForm
        noValidate
        onKeyPress={(event) => {
          if (event.which === 13 /* Enter */) {
            event.preventDefault();
          }
        }}
        className={classes.form}
        method="POST"
        onSubmit={handleSubmitForm}
        onError={(errors) => console.log(errors)}
      >
        <Grid
          style={{ marginTop: 20 }}
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          {guaranteeInfo && guaranteeInfo.serviceTicket ? (
            <>
              <Grid item xs={12} sm={12} md={4} style={{ marginRight: 15 }}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Nombre
                  </Typography>
                  <TextValidator
                    className={classes.textField}
                    fullWidth
                    disabled={guaranteeInfo !== undefined}
                    name="clientName"
                    value={guaranteeInfo.client?.name || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Teléfono
                  </Typography>
                  <TextValidator
                    className={classes.textField}
                    fullWidth
                    disabled={guaranteeInfo !== undefined}
                    name="telephone"
                    value={guaranteeInfo.client?.telephone || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </>
          ) : (
            <Grid item style={{ marginLeft: -15 }}>
              <ClientInfo
                clientInfo={handleClientFound}
                showTitle={false}
                addClient={false}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={12} md={8}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Notas adicionales
              </Typography>
              <TextValidator
                className={classes.textField}
                fullWidth
                disabled={guaranteeInfo !== undefined}
                name="notes"
                value={guaranteeObject.notes || ""}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
              />
            </Box>
          </Grid>

          {!guaranteeInfo && (
            <>
              <Grid item xs={12} sm={12} md={12}>
                <Box className={classes.box}>
                  <CategorySelect
                    title=" Seleccionar tipo de producto"
                    category={handleCategorySelected}
                    removeChip
                  />
                </Box>
              </Grid>

              {optionSelected === 1 && (
                <>
                  <Grid item xs={12} sm={12} md={5}>
                    <Box className={classes.box}>
                      <Typography
                        variant="body2"
                        component={"div"}
                        className={classes.label}
                      >
                        IMEI
                      </Typography>
                      <InputMask
                        mask="999999999999999"
                        maskChar=""
                        value={guaranteeObject.imeiCode || ""}
                        onChange={(e) => handleInputText(e)}
                      >
                        {() => (
                          <TextValidator
                            className={classes.inputField}
                            name="imeiCode"
                            placeholder="Escanea o escribe el código IMEI"
                            validators={["required"]}
                            errorMessages={["El IMEI es requerido"]}
                            variant="outlined"
                            inputProps={{
                              maxLength: 20,
                            }}
                          ></TextValidator>
                        )}
                      </InputMask>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={5}>
                    <Box className={classes.box}>
                      <Button
                        className={classes.rightButton}
                        variant="contained"
                        disabled={clientId === null}
                        color="primary"
                        type="submit"
                        onClick={(e) => recoverMovileDetail(e)}
                        style={{ marginRight: 50, width: 200 }}
                      >
                        Buscar Equipo Móvil
                      </Button>
                    </Box>
                  </Grid>
                </>
              )}

              {optionSelected === 2 && (
                <>
                  <Grid item xs={12} sm={12} md={5}>
                    <Box className={classes.box}>
                      <Typography
                        variant="body2"
                        component={"div"}
                        className={classes.label}
                      >
                        Código de barras
                      </Typography>
                      <InputMask
                        mask="99999999999999999999"
                        maskChar=""
                        value={barCode || ""}
                        onChange={(e) => handleBarCode(e)}
                      >
                        {() => (
                          <TextValidator
                            className={classes.inputField}
                            name="imeiCode"
                            placeholder="Escanea o escribe el código de barras"
                            validators={["required"]}
                            errorMessages={["El código de barras es requerido"]}
                            variant="outlined"
                            inputProps={{
                              maxLength: 20,
                            }}
                          ></TextValidator>
                        )}
                      </InputMask>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={5}>
                    <Box className={classes.box}>
                      <Button
                        className={classes.rightButton}
                        variant="contained"
                        disabled={clientId === null}
                        color="primary"
                        type="submit"
                        onClick={(e) => recoverAccesoryInfo(e)}
                        style={{ marginRight: 50, width: 200 }}
                      >
                        Buscar accesorio
                      </Button>
                    </Box>
                  </Grid>
                </>
              )}
            </>
          )}

          <Grid item xs={12}>
            {productDetail &&
              Object.values(productDetail).length > 0 &&
              Object.values(sellInfo).length > 0 && (
                <Box mt={5}>
                  <Typography variant="h5" className={classes.detailTitle}>
                    Detalles del producto
                  </Typography>
                  <ProductResume
                    productDetail={productDetail}
                    sellInfo={sellInfo}
                    isAccesory={productDetail.subcategory_type}
                  />
                </Box>
              )}
          </Grid>

          {!guaranteeInfo && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="flex-end"
            >
              <Grid item>
                <Button
                  className={classes.rightButton}
                  disabled={!productDetail || clientId === null}
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ margin: 50, width: 200 }}
                >
                  Generar garantía
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </ValidatorForm>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(NewGuarantee);
